export function creditHundredths(courses: ReadonlyArray<{ credits: number | null | undefined }>): number {
  return courses.reduce((total, course) =>
    total + (course.credits == null || !Number.isFinite(course.credits) ? 0 : Math.round(course.credits * 100)), 0);
}

export function formatCreditHours(hundredths: number): string {
  return (hundredths / 100).toFixed(2);
}
